<script>
import CoreComponent from '../../../../../../../dow-platform/ui.frontend/src/dow-platform/components/core/CoreComponent.vue'

export default {
    extends: CoreComponent,

    mounted() {
        let select = this.cmpEl.querySelector("select");
        if (select) {
            select.addEventListener("change", e => {
                window.open(select.value);
                select.value = '';
            });
        }
    }
}
</script>

<style lang="scss">
@import './asset-list.scss';
</style>
